import { createFileRoute } from '@tanstack/react-router'
import { GoldBuyRequestsTable } from '@/features/gold-buy-requests'

export const Route = createFileRoute(
  '/_authenticated/wallet/gold-buy-requests'
)({
  component: GoldBuyRequestsPage,
})

function GoldBuyRequestsPage() {
  return <GoldBuyRequestsTable />
}
